import environment from "../environment";

const env = environment();
export const USER_URL = `${env.selfUrl}/users`;
export const SEARCH_URL = `${env.selfUrl}/search`;

export const UserApi = {
    getUserDetail: `${USER_URL}/details`,
    getUserSelf: `${USER_URL}/self`,
    getUserProfileQuestions: `${USER_URL}/questions`,
    findUser: `${USER_URL}/find`,
    getSchools: `${SEARCH_URL}/school`,
    getSchoolByXid: (xid) => `${SEARCH_URL}/school/urn:com.mheducation.openlearning:enterprise.identity.organization:${env.env}.global:organization:${xid}/hierarchy`,
    getDepartments: (countryCode) => `${env.selfUrl}/lists/departments?countryCode=${countryCode}`,
    getDisciplines: `${env.selfUrl}/lists/disciplines`,
    getProducts: `${env.selfUrl}/products/`,
    signout: `${env.selfUrl}/logout`,
}
